import React, { useState } from 'react'
import DashboardLayout from 'layout/DashboardLayout'
import WalletBalance from './components/Wallet'
import AccountDetails from './components/AccountDetails'
import TransactionDetailsModal from 'components/Modals/TransactionDetails'
import TransactionHistory from './components/TransactionHistory'

const Wallet = () => {
    const [showModal, setShowModal] = useState(false)

    return (
        <DashboardLayout>
            <div className='w-10/12 mx-auto grid grid-cols-9 mt-5 md:mt-12 gap-10 lg:gap-6 xl:gap-10'>
                <div className='col-span-9 lg:col-span-3 md:flex lg:block'>
                    <div className='md:w-1/2 lg:w-auto'>
                        <WalletBalance />
                    </div>
                    <div className='lg:mt-5 md:ml-3 lg:ml-0 md:mt-0 mt-5'>
                        <AccountDetails />
                    </div>
                </div>
                <div className='col-span-9 lg:col-span-6'>
                    <div className='flex items-center mb-3 justify-between md:justify-start'>
                        <button className='text-lg font-medium text-dark tracking-wide'>Transaction history</button>
                        <button className='text-lg font-medium text-dark tracking-wide ml-5 opacity-25'>
                            Pending invoice
                        </button>
                    </div>
                    <TransactionHistory open={() => setShowModal(true)} />
                </div>
            </div>
            <div className="mb-32 lg:mb-0">
                <TransactionDetailsModal show={showModal} close={() => setShowModal(false)} />
            </div>
        </DashboardLayout>
    )
}

export default Wallet
